<template>

	<div class="container mt-5" v-if="shelf === false">
		<p>loading ...</p>
	</div>
	<div v-else-if="shelf">

		<shelf-container
			ref="shelf-class"
			:shelf="shelf"
			@removed="eventRemoveShelf"
			@updated="eventUpdateShelf"
			@book-added="eventBookAdded"
		>
			<template #content="{method}">

				<div class="bg-white py-2">
					<div class="container">
						<div class="d-md-flex align-items-center flex-row-reverse">

							<div class="ms-auto float-end mt-1 mt-md-0">
								<div class="hstack gap-4 justify-content-end">
									<div class="d-none d-lg-block">
										<button type="button" class="btn btn-primary" @click="method.addBook">Добавить&nbsp;книгу</button>
									</div>

									<div class="dropdown">
										<button type="button" class="btn btn-link d-flex align-items-center p-0 text-decoration-none" data-bs-toggle="dropdown">
											<svg width="36" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
												<g fill="currentColor">
													<path d="M30.391,12.68l-3.064-0.614c-0.154-0.443-0.336-0.873-0.537-1.289l1.736-2.604   c0.529-0.793,0.424-1.85-0.25-2.523l-1.924-1.924c-0.387-0.387-0.898-0.586-1.416-0.586c-0.383,0-0.77,0.11-1.107,0.336   l-2.604,1.735c-0.418-0.202-0.848-0.382-1.291-0.536L19.32,1.61c-0.186-0.936-1.008-1.608-1.961-1.608h-2.72   c-0.953,0-1.774,0.673-1.961,1.608l-0.614,3.065c-0.443,0.154-0.873,0.335-1.289,0.536L8.172,3.476   C7.833,3.25,7.447,3.14,7.063,3.14c-0.517,0-1.028,0.199-1.415,0.586L3.725,5.65c-0.674,0.674-0.779,1.73-0.25,2.523l1.735,2.604   c-0.202,0.417-0.382,0.847-0.536,1.29L1.608,12.68C0.673,12.867,0,13.688,0,14.641v2.72c0,0.953,0.673,1.775,1.608,1.961   l3.065,0.615c0.154,0.443,0.335,0.873,0.536,1.289L3.475,23.83c-0.529,0.793-0.424,1.85,0.25,2.523l1.924,1.924   c0.387,0.387,0.898,0.586,1.415,0.586c0.384,0,0.771-0.111,1.108-0.336l2.604-1.736c0.417,0.203,0.847,0.383,1.29,0.537   l0.613,3.064c0.187,0.936,1.008,1.609,1.961,1.609h2.72c0.953,0,1.775-0.674,1.961-1.609l0.615-3.064   c0.443-0.154,0.873-0.336,1.289-0.537l2.604,1.736c0.338,0.225,0.725,0.336,1.107,0.336c0.518,0,1.029-0.199,1.416-0.586   l1.924-1.924c0.674-0.674,0.779-1.73,0.25-2.523l-1.736-2.604c0.203-0.418,0.383-0.848,0.537-1.291l3.064-0.613   C31.326,19.137,32,18.314,32,17.361v-2.72C32,13.688,31.326,12.867,30.391,12.68z M26.934,17.975   c-0.695,0.139-1.264,0.635-1.496,1.305c-0.129,0.369-0.279,0.727-0.447,1.074c-0.311,0.639-0.258,1.393,0.135,1.982l1.736,2.604   l-1.924,1.924l-2.604-1.736c-0.334-0.223-0.721-0.336-1.109-0.336c-0.297,0-0.596,0.066-0.871,0.199   c-0.348,0.168-0.705,0.32-1.076,0.449c-0.668,0.232-1.164,0.801-1.303,1.496l-0.615,3.066h-2.72l-0.613-3.066   c-0.139-0.695-0.635-1.264-1.304-1.496c-0.369-0.129-0.728-0.279-1.075-0.447c-0.276-0.135-0.574-0.201-0.872-0.201   c-0.389,0-0.775,0.113-1.109,0.336l-2.604,1.736l-1.924-1.924l1.735-2.604c0.393-0.59,0.444-1.344,0.137-1.98   c-0.168-0.348-0.319-0.705-0.448-1.076c-0.232-0.668-0.802-1.164-1.496-1.303l-3.065-0.615L2,14.641l3.066-0.613   c0.694-0.139,1.264-0.635,1.496-1.304c0.129-0.369,0.278-0.728,0.447-1.075c0.31-0.638,0.258-1.392-0.136-1.981L5.139,7.064   L7.062,5.14l2.604,1.735C10,7.098,10.387,7.211,10.775,7.211c0.297,0,0.595-0.066,0.871-0.199c0.347-0.168,0.705-0.319,1.075-0.448   c0.669-0.232,1.165-0.802,1.304-1.496l0.614-3.065l2.72-0.001l0.613,3.066c0.139,0.694,0.635,1.264,1.305,1.496   c0.369,0.129,0.727,0.278,1.074,0.447c0.277,0.134,0.574,0.2,0.873,0.2c0.389,0,0.775-0.113,1.109-0.336l2.604-1.735l1.924,1.924   l-1.736,2.604c-0.393,0.59-0.443,1.343-0.137,1.98c0.168,0.347,0.32,0.705,0.449,1.075c0.232,0.669,0.801,1.165,1.496,1.304   l3.064,0.614L30,17.361L26.934,17.975z"/>
													<path d="M16,9.001c-3.865,0-7,3.135-7,7c0,3.866,3.135,7,7,7s7-3.135,7-7C23,12.136,19.865,9.001,16,9.001z    M16,22.127c-3.382,0-6.125-2.744-6.125-6.125c0-3.382,2.743-6.125,6.125-6.125c3.381,0,6.125,2.743,6.125,6.125   C22.125,19.383,19.381,22.127,16,22.127z"/>
													<path d="M16,12.001c-2.21,0-4,1.79-4,4c0,2.209,1.79,4,4,4c2.209,0,4-1.791,4-4C20,13.792,18.209,12.001,16,12.001z    M16,19.002c-1.656,0-3-1.344-3-3c0-1.656,1.344-3,3-3s3,1.344,3,3C19,17.658,17.656,19.002,16,19.002z"/>
												</g>
											</svg>
											<span class="ms-1 d-none d-xxl-block">действия</span>
										</button>
										<nav class="dropdown-menu dropdown-menu-end">
											<a href="#" class="dropdown-item d-lg-none" @click.prevent="method.addBook">Добавить книгу</a>
											<a href="#" class="dropdown-item" @click.prevent="method.edit">Редактировать полку</a>
											<a href="#" class="dropdown-item text-danger" @click.prevent="method.remove">Удалить полку</a>
										</nav>
									</div>
								</div>
							</div>

							<app-breadcrumbs :items="[
								{name: category.title, url: {name: category.routerName}},
							]">
								<h1 class="title-primary m-0">{{shelf.name}}</h1>
							</app-breadcrumbs>

						</div>
					</div>
				</div>

				<div class="container mt-5">
					<div class="row g-3 g-lg-5">
						<div v-for="book in shelf.books" :key="book.id" class="col-6 col-sm-4 col-lg-3">

							<book-card :book="book" :shelf="{id: shelf.id}"/>

						</div>
						<div class="col-6 col-sm-4 col-lg-3">
							<div class="ratio ratio-1x1">
								<button type="button" class="btn bg-white btn-link" @click="method.addBook" style="line-height: 1;">
									<svg width="52" height="52" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path fill="currentColor" d="M3 4.5C3 3.11929 4.11929 2 5.5 2H17C18.3807 2 19.5 3.11929 19.5 4.5V11.3135C19.0218 11.159 18.5195 11.0585 18 11.0189V4.5C18 3.94772 17.5523 3.5 17 3.5H5.5C4.94772 3.5 4.5 3.94772 4.5 4.5V18H11.0189C11.0585 18.5195 11.159 19.0218 11.3135 19.5H4.5C4.5 20.0523 4.94772 20.5 5.5 20.5H11.7322C12.0194 21.051 12.3832 21.5557 12.8096 22H5.5C4.11929 22 3 20.8807 3 19.5V4.5ZM17.5 12C20.5376 12 23 14.4624 23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12ZM18.0011 20.5035L18.0006 18H20.503C20.7792 18 21.003 17.7762 21.003 17.5C21.003 17.2239 20.7792 17 20.503 17H18.0005L18 14.4993C18 14.2231 17.7761 13.9993 17.5 13.9993C17.2239 13.9993 17 14.2231 17 14.4993L17.0005 17H14.4961C14.22 17 13.9961 17.2239 13.9961 17.5C13.9961 17.7762 14.22 18 14.4961 18H17.0006L17.0011 20.5035C17.0011 20.7797 17.225 21.0035 17.5011 21.0035C17.7773 21.0035 18.0011 20.7797 18.0011 20.5035ZM6 6C6 5.44772 6.44772 5 7 5H15C15.5523 5 16 5.44772 16 6V8C16 8.55228 15.5523 9 15 9H7C6.44772 9 6 8.55228 6 8V6ZM7.5 7.5H14.5V6.5H7.5V7.5Z"/>
									</svg>
									<span class="d-block mt-2">Добавить книгу</span>
								</button>
							</div>
						</div>
					</div>
				</div>

<!--				<fab-dropdown>-->
<!--					<a href="#" class="dropdown-item" @click.prevent="method.addBook">Добавить книгу</a>-->
<!--					<a href="#" class="dropdown-item" @click.prevent="method.edit">Редактировать полку</a>-->
<!--					<a href="#" class="dropdown-item text-danger" @click.prevent="method.remove">Удалить полку</a>-->
<!--				</fab-dropdown>-->

			</template>
		</shelf-container>

	</div>

</template>
<script>
import SHELF from '@/models/shelf'
import CATEGORY from '@/models/category'
// import FabDropdown from '@/components/fab-dropdown'
import BookCard from '@/components/book-card'
import ShelfContainer from '@/components/shelf-container'

export default {
	data() {
		return {
			shelf: null,
		}
	},
	methods: {
		loadShelf(id) {
			this.shelf = false; // start loading

			this.userapi.get(`racks/${id}`).then(response => {
				this.shelf = response.data.id ? SHELF.formatServerData(response.data) : null;
				this.category = this.shelf ? CATEGORY.find(this.shelf.category) : null;
			}).catch(() => this.shelf = null);
		},

		// shelf was updated
		eventUpdateShelf(id, mode, data) {
			if (mode === 'edit') {
				this.shelf = SHELF.formatServerData(data);
			}
		},

		// shelf was removed
		eventRemoveShelf(id) {
			this.$router.push({name: this.category.routerName});
		},

		// book was added to shelf
		eventBookAdded(id, book) {
			this.shelf.books.push(book);
		}
	},
	mounted() {
		this.loadShelf(this.$route.params.idShelf);
	},
	components: {
		ShelfContainer,
		BookCard,
		// FabDropdown
	}
}
</script>